// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements


document.addEventListener('DOMContentLoaded', function () {
    const blockBlockSlideQuerySlider = document.querySelector('.wp-block-blockslide-query-slider');
    if (!blockBlockSlideQuerySlider) {
        console.error('ulElement or existingSwiperContainer not found!');
        return;
    }
    const existingSwiperContainer = blockBlockSlideQuerySlider?.querySelector('swiper-container-holder');
    const ulElement = blockBlockSlideQuerySlider?.querySelector('.wp-block-post-template');
    const loadingOverlay = blockBlockSlideQuerySlider?.querySelector('.loading-overlay');

    const newSwiperContainer = document.createElement('swiper-container');

    // Step 3: Copy attributes from the existing swiper-container-holder to the new swiper-container
    Array.from(existingSwiperContainer.attributes).forEach((attr) => {
        newSwiperContainer.setAttribute(attr.name, attr.value);
    });


    // Step 4: Move the new swiper-container inside the ul element
    ulElement.appendChild(newSwiperContainer);

    // Step 5: Wrap each li inside a swiper-slide
    const listItems = ulElement.querySelectorAll('li');
    listItems.forEach(function (li) {
        const swiperSlide = document.createElement('swiper-slide');
        swiperSlide.appendChild(li); // Move the li inside the swiper-slide
        newSwiperContainer.appendChild(swiperSlide); // Append swiper-slide to new swiper-container
    });

    if (loadingOverlay) {
        loadingOverlay.remove();
    }

    register();

    const params = {
        injectStyles: [
            `
.swiper-button-next,
        .swiper-button-prev {
	background-color: var(--wp--preset--color--accent);
	height: 3.5rem;
	width: 3.5rem;
}  
    .swiper-button-next svg,
        .swiper-button-prev svg {width: 20px; height: 20px; color:var(--wp--preset--color--contrast);}
        .swiper-pagination-bullet-active {background-color: var(--wp--preset--color--accent);
        }
           .nav-position-bottom-right .swiper-button-next, .nav-position-bottom-right .swiper-button-prev {
	bottom: 0 !important; 
    top: initial !important; 
}
            `,
        ],
    };

    if (newSwiperContainer.classList.contains('nav-position-bottom-right')) {
        params.injectStyles.push(`
            .swiper-button-next,
            .swiper-button-prev {
                bottom: 0 !important;
                top: initial !important;
                z-index:100;
            }
            .swiper-button-next {
                right:0;
            }.swiper-button-prev {
                right:68px;
                left: initial !important;
            }
        `);
    }

    Object.assign(newSwiperContainer, params);

    newSwiperContainer.initialize();

});

